import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedBrand,
  setSelectedClass,
  setSelectedSKUs,
  setSelectedWeekStart,
  setSelectedWeekEnd,
} from "../../../Redux/promoSimulatorSlice/promoSimulatorSlice";
import { PROMO_ALL_CLASSES_ID } from "../services/promoSimulatorService";

export default function BrandSelector({ brands = [], formControlSx, loading = false }) {
  const dispatch = useDispatch();
  const selectedBrand = useSelector(
    (state) => state.promoSimulator.selectedBrand
  );

  const handleChange = (e) => {
    dispatch(setSelectedBrand(e.target.value));
    dispatch(setSelectedClass(PROMO_ALL_CLASSES_ID));
    dispatch(setSelectedSKUs([]));
    dispatch(setSelectedWeekStart(null));
    dispatch(setSelectedWeekEnd(null));
  };

  const valueInOptions = brands.some((b) => b.id === selectedBrand);
  const selectValue = loading || !valueInOptions ? "" : selectedBrand;

  return (
    <FormControl fullWidth size="small" sx={formControlSx} disabled={loading}>
      <InputLabel>Brand</InputLabel>
      <Select
        value={selectValue}
        label="Brand"
        onChange={handleChange}
        displayEmpty
      >
        {brands.map((b) => (
          <MenuItem key={b.id} value={b.id}>
            {b.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
